import React, { FC, memo, useEffect, useState } from "react";

import { SvgContainer } from "./styled";

export const FeatureCardSvg: FC<{ url: string; width?: number; fontColor?: string }> = memo(
  ({ url, width, fontColor }) => {
    const [svg, setSvg] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      if (!url || loading) return;

      setLoading(true);

      fetch(url)
        .then(res => (res.ok ? res.text() : null))
        .then(setSvg)
        .finally(() => {
          setLoading(false);
        });
    }, [url]);

    useEffect(
      () => () => {
        setSvg(null);
      },
      [],
    );

    return <SvgContainer $width={width} $fontColor={fontColor} dangerouslySetInnerHTML={{ __html: svg }} />;
  },
);
